import React from 'react'
import axios from 'axios'
import { TextField, Typography } from '@material-ui/core'

const AreaNotes = ({ areaId, initialNotes, url, onSaved }) => {
  const [notes, setNotes] = React.useState(initialNotes || '')
  const [saving, setSaving] = React.useState(false)

  React.useEffect(() => {
    setNotes(initialNotes || '')
  }, [areaId, initialNotes])

  const handleBlur = () => {
    if (notes === initialNotes) return
    setSaving(true)
    axios.put(`${url}/api/bid-estimation/areas/${areaId}`, { notes }).then(res => {
      setSaving(false)
      if (onSaved) onSaved(res.data.notes)
    }).catch(err => {
      console.error('Failed to save notes:', err)
      setSaving(false)
    })
  }

  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
        <Typography variant="subtitle2" style={{ fontWeight: 600, fontSize: 13 }}>Notes</Typography>
        {saving && <Typography variant="caption" color="textSecondary">Saving...</Typography>}
      </div>
      <TextField
        fullWidth
        multiline
        rows={4}
        rowsMax={10}
        variant="outlined"
        value={notes}
        onChange={e => setNotes(e.target.value)}
        onBlur={handleBlur}
        inputProps={{ maxLength: 5000 }}
        helperText={`${notes.length}/5000`}
      />
    </div>
  )
}

export default AreaNotes
